<template>
  <layout-view navTitle="Фильтры">
    <template v-slot:nav>
      <div class="px-4">
        <date-interval name="Дата создания" :valueFrom.sync="filter.dateFrom" :valueTo.sync="filter.dateTo"/>
        
        <checkbox-field class="mb-4" name="Только анализы" :value.sync="filter.onlyTests"/>
        
        <user-autocomplete-multiple name="Клиенты" :select.sync="filter.usersSelected" selectAllEnabled/>
        
        <v-row class="align-center mb-4 pt-1">
          <v-col>
            <direction-autocomplete-multiple class="ml-1 mb-0" :select.sync="filter.directions"/>
          </v-col>
          <v-col cols="auto">
            <tooltip right>
              <v-icon small>mdi-help-circle-outline</v-icon>           
              <template v-slot:content>
                Фильтрует клиентов по наличию медплана с соответствущим направлением.
              </template>
            </tooltip> 
          </v-col>
        </v-row>
        
        <user-autocomplete-multiple name="Специалисты" _type="spec" :select.sync="filter.usersSpecSelected" selectAllEnabled/>
        
        <text-field name="Название" :value.sync="filter.medRecordName"/>
      </div>
    </template>
    <template v-slot:content="{height}">
      <v-data-table
          :headers="headers"
          :items="medRecords"         
          :loading="loadState.isLoading"
          :itemsPerPage="100"
          dense
          fixed-header
          :height="height-60"
          class="pt-3"
          :footer-props="{'items-per-page-options': [100,250,500]}"
 
      >
        <template v-slot:item="{ item }">
          
          <tr @click="typeof item.medRecordTemplate !== 'undefined' ? medRecordId=item.id : mediaId=item.id; user = item.user;">
            <td class="text-no-wrap">{{item.id}}</td>
            <td class="text-no-wrap">
              <big-text width="500" height="32" :text="item.name!=null&&item.name!='' ? item.name : typeof item.medRecordTemplate !== 'undefined' ? item.medRecordTemplate.name : '-'"/>
              <tooltip v-if="(typeof item.medRecordTemplate === 'undefined')" right>
                <v-icon  small class="ml-1">mdi-file-document-outline</v-icon>
                <template v-slot:content>
                  Документ
                </template>
              </tooltip>
              <tooltip v-if="item.status==='unactive'" right>
                <v-icon small class="ml-2">mdi-file-alert</v-icon>
                <template v-slot:content>
                  Черновик
                </template>
              </tooltip>
              <tooltip v-if="!item.isShowInService" right>
                <v-icon v-if="!item.isShowInService" class="ml-2" size="14" color="primary">mdi-eye-off-outline</v-icon>
                <template v-slot:content>
                  Скрыто в личном кабинете
                </template>
              </tooltip>
            </td>
            <td>{{item.comment}}</td>
            <td>
              <div class="d-flex align-center text-no-wrap">
                <UserFullName :user="item.user" short/>
              </div>
            </td>
            <td class="text-no-wrap">
              <UserFullName :user="item.userAuthor" type="spec" avatar spec short/>             
            </td>
            <td class="text-no-wrap">{{$tools.dateTime(item.created)}}</td>
            <td class="text-no-wrap">
              <chip v-if="item.isSent" color="green" dark small fullWidth>Отправлено</chip>
            </td>
            <td>
                <MediaActions :item="item" :loading="loadState.isLoading" @load="load()" @mediaPreview="(v)=>mediaId=v"/>
            </td>
          </tr>
        </template>

        <template v-slot:footer.prepend>
          <tooltip right>
            <v-chip color="red lighten-5 mx-1">
              <v-icon class="mr-2" color="red" small>mdi-alert</v-icon>
              <div class="caption black--text">список ограничен</div>
            </v-chip>       
            <template v-slot:content>
              Ограничено до 2000 медзаписей. Для получения более точных результатов воспользуйтесь фильтрами.
            </template>
          </tooltip> 
        </template>
      </v-data-table>

      <med-record-update :med-record-id.sync="medRecordId" @medRecordCopied="medRecordCopied" :userId="user?.id"/>
      <media-view :media-id.sync="mediaId" :user-id="user?.id" :userName="user && $tools.userFullName(user)" @updateList="load()"/>

    </template>
  </layout-view>
</template>

<script>

import Api from "@/Api";
import State from "@/plugins/state";
import moment from "moment";
import LayoutView from "@/components/LayoutView";
import MedRecordUpdate from "@/views/MedRecord/MedRecordUpdate";
import MediaView from "@/views/Media/MediaView";
import axios from "axios";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import DirectionAutocompleteMultiple from "@/componentsV2/custom/DirectionAutocompleteMultiple.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import Chip from "@/componentsV2/base/Chip.vue";
import MediaActions from "@/componentsV2/base/MediaActions.vue";

import {
  Entity_MedRecord,
  Entity_MedRecordTemplate,
  Entity_Media,
  Entity_User,
  Entity_UserProfile,
  Entity_MediaDir,
  Entity_MedPlan,
  Entity_Direction,
  Entity_MedRecordTemplateCategory
  // Entity_Visit,
  // Entity_VisitService,
  // Entity_Service
} from "../../../EntityStoreCacheService";
import BigText from "@/componentsV2/custom/BigText.vue";

export default {
  components: {
    BigText,
    LayoutView,
    DateInterval,
    UserAutocompleteMultiple,
    MedRecordUpdate,
    MediaView,
    TextField,
    Tooltip,
    DirectionAutocompleteMultiple,
    CheckboxField,
    UserFullName,
    Chip,
    MediaActions
  },
  props: ['userSpecDesktop'],
  data:()=>({
    loadState: new State(),

    headers: [
      { text: 'ID', value: 'id', sortable: true, class:'text-no-wrap', width:'auto'},
      { text: 'Название', value: 'medRecordTemplate.name', sortable: true, class:'text-no-wrap'},
      { text: 'Комментарий', sortable: false},
      { text: 'Клиент', value: 'user.lastName', sortable: true, class:'text-no-wrap'},
      { text: 'Автор', value: 'userAuthor.lastName', sortable: true, class:'text-no-wrap'},
      { text: 'Дата создания', value: 'created', sortable: false, class:'text-no-wrap'},
      { text: 'Отправка на Email', sortable: false},
      { text: '', sortable: false},
    ],
    
    filter: {
      dateFrom: moment(new Date()).format('DD.MM.YYYY'),
      dateTo: moment(new Date()).format('DD.MM.YYYY'),
      usersSelected: [],
      usersSpecSelected:[],
      directions: [],
      medRecordName: null,
      onlyTests: false,
    },

    medRecords:[],
    medRecordId:null,

    medias: [],
    mediaId: null,

    user:null,

    previewWidth:0,
    previewHeight:0,
  }),
  mounted(){
    if (typeof this.userSpecDesktop !== 'undefined'){
        let MedPlanRequest = new Entity_MedPlan()
        //user
        .selects([Entity_MedPlan.user, Entity_User.id].join('.'))
        .selects([Entity_MedPlan.user, Entity_User.firstName].join('.'))
        .selects([Entity_MedPlan.user, Entity_User.lastName].join('.'))
        .selects([Entity_MedPlan.user, Entity_User.secondName].join('.'))

        .selects([Entity_MedPlan.user, Entity_User.userProfile, Entity_UserProfile.gender].join('.'))
        .selects([Entity_MedPlan.user, Entity_User.userProfile, Entity_UserProfile.birth].join('.'))

        .filterAnd([Entity_MedPlan.entity, Entity_MedPlan.status].join('.')+' not in (?)',['complete', 'done'])
        .filterAnd([Entity_MedPlan.entity, Entity_MedPlan.userSpec, Entity_User.id].join('.')+'=?',this.userSpecDesktop ? this.userSpecDesktop.id : this.$store.state.user.id)


        .page(1).onPage(10000);

        MedPlanRequest.request((data)=>{   
          console.log(data)
          this.usersSelected = data.items.map(i=>i.user);
          this.load();
        }, (e)=>{
          console.error(e.response.data.message);
        })
    } else {
      this.load();
    }
  },
  watch:{
    filter: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  methods:{
    load(){
      this.$tools.debounce(()=>{
        this.loadState.stateLoading();

        const promises = [];
        const medRecords = new Promise((resolve) => {               
          let medRecordRequest = new Entity_MedRecord()
            .selects(Entity_MedRecord.id)
            .selects(Entity_MedRecord.created)
            .selects(Entity_MedRecord.isSent)
            .selects(Entity_MedRecord.isPrinted)
            .selects(Entity_MedRecord.isShowInService)
            .selects(Entity_MedRecord.name)
            .selects(Entity_MedRecord.status)
            .selects(Entity_MedRecord.comment)
        

            //user
            .selects([Entity_MedRecord.user,Entity_User.id].join('.'))
            .selects([Entity_MedRecord.user,Entity_User.firstName].join('.'))
            .selects([Entity_MedRecord.user,Entity_User.lastName].join('.'))
            .selects([Entity_MedRecord.user,Entity_User.secondName].join('.'))

            //user author
            .selects([Entity_MedRecord.userAuthor, Entity_User.id].join('.'))
            .selects([Entity_MedRecord.userAuthor, Entity_User.firstName].join('.'))
            .selects([Entity_MedRecord.userAuthor, Entity_User.lastName].join('.'))
            .selects([Entity_MedRecord.userAuthor, Entity_User.secondName].join('.'))
            .selects([Entity_MedRecord.userAuthor, Entity_User.imageUrl].join('.'))

            //medRecordTemplate
            .selects([Entity_MedRecord.medRecordTemplate, Entity_MedRecordTemplate.id].join('.'))
            .selects([Entity_MedRecord.medRecordTemplate, Entity_MedRecordTemplate.name].join('.'))


            .filterAnd([Entity_MedRecord.entity, Entity_MedRecord.status].join('.')+'!=?','deleted')


            // filter by created
            if(this.filter.dateFrom)  
              medRecordRequest.filterAnd([Entity_MedRecord.entity, Entity_MedRecord.created].join('.')+'>=?',moment(this.filter.dateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
            

            if(this.filter.dateTo) 
              medRecordRequest.filterAnd([Entity_MedRecord.entity, Entity_MedRecord.created].join('.')+'<=?',moment(this.filter.dateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
            

            // filter by user
            if (this.filter.usersSelected.length>0) 
              medRecordRequest.filterAnd([Entity_MedRecord.entity, Entity_MedRecord.user, Entity_User.id ].join('.')+' in (?)',this.filter.usersSelected.map(i=>i.id))
            

            // filter by userSpec
            if (this.filter.usersSpecSelected.length>0)
              medRecordRequest.filterAnd([Entity_MedRecord.entity, Entity_MedRecord.userAuthor, Entity_User.id ].join('.')+' in (?)',this.filter.usersSpecSelected.map(i=>i.id))
            

            //filter by name
            if (this.filter.medRecordName!==null&&this.filter.medRecordName!=='')
              medRecordRequest.filterAnd([Entity_MedRecord.entity, Entity_MedRecord.name].join('.')+' LIKE ? OR '+
              [Entity_MedRecord.entity, Entity_MedRecord.medRecordTemplate, Entity_MedRecordTemplate.name].join('.')+' LIKE ?'
              ,'%'+this.filter.medRecordName+'%','%'+this.filter.medRecordName+'%');
            

            //directions
            if (this.filter.directions.length>0)
              medRecordRequest.filterAnd([Entity_MedRecord.entity, Entity_MedRecord.user, Entity_User.medPlans, Entity_MedPlan.directions, Entity_Direction.id].join('.')+' in (?)', this.filter.directions.map(i=>i.id))
            

            //анализы
            if (this.filter.onlyTests) 
              medRecordRequest.filterAnd([Entity_MedRecord.entity, Entity_MedRecord.medRecordTemplate, Entity_MedRecordTemplate.medRecordTemplateCategory, Entity_MedRecordTemplateCategory.name].join('.')+' =?','Анализы');
            

            medRecordRequest.page(1).onPage(1000)

            medRecordRequest.request((data)=>{
                resolve(data.items);
            }, (e)=>{
              console.error(e.response.data.message);
            })
        });

        promises.push(medRecords);

        const media = new Promise((resolve) => {
          let mediaRequest = new Entity_Media()
          .selects(Entity_Media.id)
          .selects(Entity_Media.created)
          .selects(Entity_Media.isSent)
          .selects(Entity_Media.isPrinted)
          .selects(Entity_Media.isShowInService)
          .selects(Entity_Media.name)
          .selects(Entity_Media.status)
          .selects(Entity_Media.fileName)
          .selects(Entity_Media.type)
          .selects(Entity_Media.path)

          //user
          .selects([Entity_Media.user,Entity_User.id].join('.'))
          .selects([Entity_Media.user,Entity_User.firstName].join('.'))
          .selects([Entity_Media.user,Entity_User.lastName].join('.'))
          .selects([Entity_Media.user,Entity_User.secondName].join('.'))

          //user
          .selects([Entity_Media.userAuthor, Entity_User.id].join('.'))
          .selects([Entity_Media.userAuthor, Entity_User.firstName].join('.'))
          .selects([Entity_Media.userAuthor, Entity_User.lastName].join('.'))
          .selects([Entity_Media.userAuthor, Entity_User.secondName].join('.'))
          .selects([Entity_Media.userAuthor, Entity_User.imageUrl].join('.'))


        
          .filterAnd([Entity_Media.entity, Entity_Media.mediaDir, Entity_MediaDir.id ].join('.')+' NOT IN (?)',[1,4])//исключаем раздел договоры и справки
          .filterAnd([Entity_Media.entity, Entity_Media.status].join('.')+'!=?','deleted')


          // filter by created
          if(this.filter.dateFrom) 
            mediaRequest.filterAnd([Entity_Media.entity, Entity_Media.created].join('.')+'>=?',moment(this.filter.dateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
          

          if(this.filter.dateTo)  
            mediaRequest.filterAnd([Entity_Media.entity, Entity_Media.created].join('.')+'<=?',moment(this.filter.dateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
          

          // filter by user
          if (this.filter.usersSelected.length>0)
            mediaRequest.filterAnd([Entity_Media.entity, Entity_Media.user, Entity_User.id ].join('.')+' in (?)',this.filter.usersSelected.map(i=>i.id))
          

          // filter by userSpec
          if (this.filter.usersSpecSelected.length>0)
            mediaRequest.filterAnd([Entity_Media.entity, Entity_Media.userAuthor, Entity_User.id ].join('.')+' in (?)',this.filter.usersSpecSelected.map(i=>i.id))
          

          //filter by name
          if (this.filter.medRecordName!==null&&this.filter.medRecordName!=='')
            mediaRequest.filterAnd([Entity_Media.entity, Entity_Media.name].join('.')+' LIKE ?','%'+this.filter.medRecordName+'%');
          

          //directions
          if (this.filter.directions.length>0)
            mediaRequest.filterAnd([Entity_Media.entity, Entity_Media.user, Entity_User.medPlans, Entity_MedPlan.directions, Entity_Direction.id].join('.')+' in (?)', this.filter.directions.map(i=>i.id))
          

          //анализы
          if (this.filter.onlyTests)
            mediaRequest.filterAnd([Entity_Media.entity, Entity_Media.mediaDir, Entity_MediaDir.name].join('.')+' =?','Анализы');
          

          mediaRequest.page(1).onPage(1000)

          mediaRequest.request((data)=>{
              resolve(data.items);
          }, (e)=>{
            console.error(e.response.data.message);
          })
        });
        promises.push(media);


        Promise.all(promises).then((result) => {
          let medRecordsAndMedia = [];
          result.forEach(arr=>{
            medRecordsAndMedia = medRecordsAndMedia.concat(arr);
          })

          //sort by created
          let sortedArray = medRecordsAndMedia.slice().sort(function(a, b) {
              return new Date(b.created) - new Date(a.created);
          });


          this.medRecords = sortedArray;

          this.loadState.stateSuccess();
        }).catch((error) => {
          console.error('Error:', error);
          this.loadState.stateError(error)
        }); 
      }, 500, 'medRecords')    
    },
    medRecordCopied(id){
      this.medRecordId = id;
    },
    misDesktopOpenFile(v){
      axios.get(Api.host + '/media/media/' + v.id + '/').then(r1 => {
        let mediaData = r1.data;
        this.$tools.misDesktopOpenFile(
            mediaData.path,
            mediaData.name + mediaData.path.substring(mediaData.path.lastIndexOf('.')),
            "https://"+window.location.hostname+"/api/media/media/upload/desktop/",
            {
              id: v.id,
            },
            ()=>{
              this.$store.commit('alertSuccess', 'Файл открывается локально');
            }, ()=>{
              this.$store.commit('alertError', 'Не удалось открыть файл локально');
            }
        );
      });
    }
  }
}
</script>